export const TOTAL_MIN_AMOUNT = 0;
export const TOTAL_MAX_AMOUNT = 999999999999;
export const REQUEST_DESCRIPTION_MAX_LENGTH = 5000;
export const REQUEST_NAME_MAX_LENGTH = 255;
export const STANDALONE_EXCLUDED_ATTRIBUTES = ['class', 'data-placeholder'];
